import { LearningSectionEnum } from "../../student-bookings/enum/learning-section.enum";

export class LearningSectionList {

  private static target: LearningSection = {
    sectionType: LearningSectionEnum.Target,
    sectionDescription: "Set assessment and progress targets for learner(s)"
  };

  private static assessment: LearningSection = {
    sectionType: LearningSectionEnum.Assessment,
    sectionDescription: "Assign and review assessments for learner(s)"
  };

  private static progress: LearningSection = {
    sectionType: LearningSectionEnum.Progress,
    sectionDescription: "Set learner(s) current progression level"
  };

  // private static observation: LearningSection = {
  //   sectionType: LearningSectionEnum.Observation,
  //   sectionDescription: "Record an observation or note about the learner(s)"
  // };

  private static document: LearningSection = {
    sectionType: LearningSectionEnum.Document,
    sectionDescription: "Attached and manage documents about the learner"
  };

  static learnerSections: LearningSection[] = [
    this.target,
    this.assessment,
    this.progress,
//    this.observation,
    this.document
  ];

  static studentLearnerSections: LearningSection[] = [
    this.document
  ];
}

export class LearningSection {
  sectionType : LearningSectionEnum;
  sectionDescription: string
}
